import { TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
var EmpresaComponent = /** @class */ (function () {
    function EmpresaComponent(fb, _userService, rutValidator, dialog, spinner) {
        this.fb = fb;
        this._userService = _userService;
        this.dialog = dialog;
        this.spinner = spinner;
        this.rows = [];
        this.nombreComuna = new FormControl('', [Validators.required]);
        this.options = [];
        this.selectedEmp = null;
        this.matcher = new FormService();
        this.regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        this.rut_emp = this.fb.group({
            rut: ['', [Validators.required, rutValidator]]
        });
        this.mail_emp = this.fb.group({
            mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
        });
        if (!JSON.parse(localStorage.getItem("empresas"))) {
            localStorage.setItem("empresas", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("empresas"));
        }
        this.invalidRut = true;
        this.empresa = { rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
    }
    EmpresaComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getComunas();
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    EmpresaComponent.prototype._filter = function (value) {
        var filterValue = value.toLowerCase();
        return this.options.filter(function (option) { return option.toLowerCase().includes(filterValue); });
    };
    EmpresaComponent.prototype.get_empresa = function (rut) {
        var _this = this;
        window.scroll(0, 0);
        var rut_orig = rut;
        var dv;
        if (rut.includes("-")) {
            var fullRut = rut.split("-");
            rut = fullRut[0];
            dv = fullRut[1];
        }
        else {
            dv = rut;
            rut = rut.toString();
            rut = rut.substring(0, rut.length - 1);
            dv = dv.slice(-1);
        }
        console.log("este es el rut limpio", rut);
        if (rut >= 50000000) {
            this.isNatural = false;
        }
        else {
            this.isNatural = true;
        }
        this.spinner.show();
        this.cleanData();
        this._userService.getEmpresa(rut_orig).subscribe(function (response) {
            console.log("get_empresa response", response);
            if (response.message) {
                _this.empresa.rut = rut ? rut : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
            else {
                _this.empresa.rut = response.rut ? response.rut : '';
                _this.empresa.nombre = response.nombre ? response.nombre : '';
                _this.empresa.direccion = response.direccion ? response.direccion : '';
                _this.empresa.direccion_num = response.direccion_num ? response.direccion_num : '';
                _this.empresa.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                _this.empresa.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                _this.empresa.comuna = response.comuna ? response.comuna : '';
                _this.empresa.fono = response.fono ? response.fono : '';
                _this.empresa.fax = response.fono ? response.fax : '';
                _this.empresa.mail = response.mail ? response.mail : '';
                _this.empresa.recordId = response.recordId ? response.recordId : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    EmpresaComponent.prototype.cleanData = function () {
        this.empresa = { rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
        this.rut_emp.reset();
    };
    EmpresaComponent.prototype.update_empresa = function (rut, id) {
        this.get_empresa(rut);
        this.selectedEmp = id;
    };
    EmpresaComponent.prototype.saveEmpresa = function () {
        var _this = this;
        window.scroll(0, 0);
        //por si escriben un rut que ya esté ingresado
        for (var x = 0; x < this.rows.length; x++) {
            if (this.empresa.rut == this.rows[x].rut) {
                this.delete_empresa(x);
            }
        }
        //elimina fila cuando la editan
        /*if (this.selectedEmp != null) {
            this.delete_empresa(this.selectedEmp);
            this.selectedEmp = null;
        }*/
        this.spinner.show();
        this._userService.saveEmpresa(this.empresa).subscribe(function (response) {
            _this.spinner.hide();
            console.log(response);
            if (response.update || response.save) {
                $("#emp_modal").modal("hide");
                _this.actualRow = localStorage.getItem("empresas");
                _this.rows = JSON.parse(_this.actualRow);
                _this.rows = _this.rows.concat({
                    rut: _this.empresa.rut,
                    nombre: _this.empresa.nombre,
                    direccion: _this.empresa.direccion,
                    direccion_num: _this.empresa.direccion_num,
                    direccion_complemento: _this.empresa.direccion_complemento,
                    direccion_completa: _this.empresa.direccion_completa,
                    comuna: _this.empresa.comuna,
                    fono: _this.empresa.fono,
                    fax: _this.empresa.fax,
                    mail: _this.empresa.mail
                });
                localStorage.setItem("empresas", JSON.stringify(_this.rows));
                _this.empresa = { rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
                _this.rut_emp.reset();
                _this.dialog.closeAll();
            }
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
        });
    };
    EmpresaComponent.prototype.delete_empresa = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("empresas", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('empresas'));
            }
        }
    };
    EmpresaComponent.prototype.getComunas = function () {
        var _this = this;
        this._userService.getComunas().subscribe(function (res) {
            //console.log('res', res);
            for (var i = 0; i < res.length; i++) {
                _this.options.push(res[i].fieldData.COM_Nombre);
            }
            _this.filteredOptions = _this.nombreComuna.valueChanges
                .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
        }, function (error) {
            console.log(error);
        });
    };
    return EmpresaComponent;
}());
export { EmpresaComponent };
